import React from "react";

export default function Err() {
  return (
    <div>You have visited a non-exist page</div>
  );
}